import styled from 'styled-components';

import { primitive } from '../../designTokens/primitives';
import { mediaQuery } from '../../globalStyles';
import { Cell } from '../cell';
import { Grid } from '../grid';

export const Wrapper = styled.section`
  display: grid;
  grid-auto-flow: row;
  background: ${(p) => p.theme.token('background-pattern')};
  padding: 0 0 ${primitive.$spacing6} 0;

  @media ${mediaQuery.tablet} {
    width: inherit;
    background: none;
    padding: 0;
    margin: auto;
    justify-content: center;
  }
`;

export const StyledGrid = styled(Grid)`
  margin: 0 0 0 6%;

  // setting the original Grid margin values
  @media ${mediaQuery.tablet} {
    margin: 0 6%;
  }
  @media ${mediaQuery.desktopLarge} {
    margin: 0 auto;
  }
`;

export const ListWrapper = styled(Cell)`
  width: 100%;
  overflow: auto;
  position: relative;

  @media ${mediaQuery.tablet} {
    overflow: hidden;
  }
`;

export const ListContainer = styled.ul<{
  $offset: number;
  $totalCards: number;
  $cardsPerPage: number;
}>`
  padding-inline-start: 0;
  margin: 0;
  display: flex;
  width: 100%;
  & > li {
    padding-right: ${primitive.$spacing2};
    :last-child {
      padding-right: ${primitive.$spacing6};
    }
  }

  @media ${mediaQuery.tablet} {
    justify-content: space-around;
    min-width: 100%;
    width: calc((100% / ${(p) => p.$cardsPerPage}) * ${(p) => p.$totalCards});
    transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
    transform: translateX(calc(-${(p) => p.$offset / p.$totalCards} * 100%));
    & > li {
      padding-right: ${primitive.$spacing4};
      :last-child {
        padding-right: unset;
      }
    }
  }
`;

export const SideButtonWrapper = styled(Cell)`
  display: none;
  min-width: 40px;

  @media ${mediaQuery.tablet} {
    display: flex;
    align-items: center;
  }
`;
